import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import AuthLayout from "./AuthLayout";
import { verifyOtpBuyer, verifyOtpForgetPassword, resendOtp } from "../../api/auth";
import { loginSuccess } from "../../store/authSlice";

export default function VerifyOtp() {
	const { state } = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [otp, setOtp] = useState("");
	const [loading, setLoading] = useState(false);

	const purpose = state?.purpose || "signup"; // "signup" | "forgot-password"
	const email = state?.email;
	const mobileNumber = state?.mobileNumber;

	if (!email) {
		return (
			<AuthLayout heading="Verify OTP">
				<div className="mb-3">We couldn't find a pending verification. Please start again.</div>
				<Link to="/login" className="btn-outline">Back to login</Link>
			</AuthLayout>
		);
	}

	const handleVerify = async () => {
		if (otp.length !== 4 && otp.length !== 6) {
			toast.error("Enter the complete OTP");
			return;
		}
		setLoading(true);
		if (purpose === "forgot-password") {
			const res = await verifyOtpForgetPassword({ email, otp });
			setLoading(false);
			if (res && !res.error) {
				navigate("/forgot-password", { state: { step: "reset", email, otpToken: res.data?.token || otp } });
			} else {
				toast.error(res?.msg || "Invalid OTP");
			}
		} else {
			const res = await verifyOtpBuyer({ email, otp });
			setLoading(false);
			if (res && !res.error) {
				if (res.data?.token) {
					dispatch(loginSuccess(res.data.token, res.data));
					toast.success("Account verified!");
					navigate("/company-setup");
				} else {
					toast.success("Account verified! Please log in.");
					navigate("/login");
				}
			} else {
				toast.error(res?.msg || "Invalid OTP");
			}
		}
	};

	const handleResend = async () => {
		const res = await resendOtp({ email });
		if (res && !res.error) toast.success("OTP resent");
		else toast.error(res?.msg || "Could not resend OTP");
	};

	return (
		<AuthLayout heading="Verify your account" subheading={`Enter the code sent to ${mobileNumber ? "+1" + mobileNumber : email}`}>
			<div className="mb-4 d-flex justify-content-center">
				<OtpInput
					value={otp}
					onChange={setOtp}
					numInputs={4}
					renderSeparator={<span style={{ width: 10 }} />}
					renderInput={(props) => <input {...props} className="form-control text-center" style={{ width: 52, height: 52, fontSize: 20 }} />}
				/>
			</div>
			<button className="btn-accent-solid w-100 mb-3" disabled={loading} onClick={handleVerify}>
				{loading ? "Verifying..." : "Verify"}
			</button>
			<div className="text-center small">
				Didn't get a code?{" "}
				<button type="button" className="btn btn-link p-0" onClick={handleResend}>
					Resend OTP
				</button>
			</div>
		</AuthLayout>
	);
}
